module.exports = __webpack_public_path__ + "static/media/CEO_Daedong.649e11b9.jpg";